/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Flex,
  Group,
  Modal,
  Select,
  Text,
  Textarea,
} from "@mantine/core";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import { TEMPLATE_SECTION_BODY_PLACEHOLDER } from "@/utils/constants";
import { appShowNotification } from "@/utils/utils";
import { createTemplateTextbox } from "@/graphql/mutations";
import { databaseMigrationAdapter } from "@/services/DatabaseMigrationAdapter";
import {
  CreateTemplateTextboxInput,
  CreateTemplateTextboxMutation,
  CreateTemplateTextboxMutationVariables,
} from "@/API";

const client = generateClient();

type addNewSectionTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  fetchTemplate: (templateId: string) => void;
};

const AddTextBoxTemplateModal = (props: addNewSectionTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sections, setSections] = useState();
  const [sectionId, setSectionId] = useState<any>();
  const [fieldValue, setFieldValue] = useState("");
  const defaultValueRef = useRef(null);

  const handleInsertInput = async () => {
    const inputMaster = "#INPUT#";
    const textarea: any = defaultValueRef.current;
    const { selectionStart, selectionEnd }: any = textarea;
    const newText =
      fieldValue.substring(0, selectionStart) +
      inputMaster +
      fieldValue.substring(selectionEnd);
    setFieldValue(newText);
    textarea.focus();
  };
  useEffect(() => {
    if (modalOpened && !sections) {
      closeAndResetModal();
      appShowNotification({
        title: "Please create simple section first!",
        type: "warning",
      });
    }
  }, [modalOpened]);

  useEffect(() => {
    if (!template?.sections) {
      return;
    }
    const initSections = template.sections.items
      .filter((section: any) => section.isSimple === true)
      ?.map((section: any) => {
        return { value: section.id, label: section.name };
      });

    if (initSections?.length > 0) {
      setSections(initSections);
      setSectionId(initSections[0].value);
    }
  }, [template, modalOpened]);

  const handleAddTextBox = async () => {
    if (fieldValue == "" || !sectionId) {
      setErrorMsg("Please provide a default value and section");
      return;
    }
    setErrorMsg("");
    setIsLoading(true);
    try {
      try {
        const createTextboxInput: CreateTemplateTextboxInput = {
          value: fieldValue,
          sID: sectionId,
          tID: template.id,
        };

        const createTextboxVars: CreateTemplateTextboxMutationVariables = {
          input: createTextboxInput,
        };

        console.log('[REACT-HOOK] Calling Amplify createTemplateTextbox GraphQL mutation');
        const createTextboxResult = await client.graphql<
          GraphQLQuery<CreateTemplateTextboxMutation>
        >({ query: createTemplateTextbox, variables: createTextboxVars });
        
        console.log('[REACT-HOOK] Amplify textbox creation successful, calling database migration service');
        // Call database migration service for logging and dual-write
        await databaseMigrationAdapter.handleTextboxOperation('CREATE', createTextboxInput, createTextboxResult as unknown as Record<string, unknown>);
        
        console.log(createTextboxResult);
      } catch (err) {
        console.log("error creating template field:", err);
      }
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error creating sub section:", err);
      setIsLoading(false);
    }
  };

  const closeAndResetModal = () => {
    setModalOpened(false);
    setErrorMsg("");
    setFieldValue("");
  };
  return (
    <Modal
      opened={modalOpened}
      onClose={closeAndResetModal}
      title="Add textbox"
    >
      <Flex flex={1} align={"center"} justify={"space-between"}>
        <Text>Default value</Text>
        <Button variant="transparent" p={0} onClick={handleInsertInput}>
          Insert input
        </Button>
      </Flex>
      <Textarea
        label=""
        ref={defaultValueRef}
        placeholder={TEMPLATE_SECTION_BODY_PLACEHOLDER}
        value={fieldValue}
        minRows={4}
        onChange={(event) => setFieldValue(event.target.value)}
        autosize
        resize="vertical"
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Select
        placeholder="Select section"
        label="Section"
        data={sections}
        value={sectionId}
        onChange={(_value, option) => setSectionId(option.value)}
      />

      <Group mt="md">
        <Group mt="md">
          <Button loading={isLoading} onClick={handleAddTextBox}>
            Save
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default AddTextBoxTemplateModal;
